import { Button, Modal, ModalProps } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { getListIndexTable, updateIndexTable } from "../../../api/table";
import { useMutation, useQuery } from "react-query";

import Cookies from "js-cookie";
import TableItem from "../../TableItem";
import { TakuSetteiStaff } from "../../TakuSetteiStaff";
import { UserPlan } from "constants/enum";
import classNames from "classnames";
import { getListTableSession } from "../../../api/tableSession";
import { queryKeys } from "../../../constants/constans";
import styles from "./styles.module.scss";
import useIsMobile from "../../../hooks/useIsMobile";
import useSetOrderList from "../../../hooks/useSetOrderList";
import useSetTimeLineInfo from "../../../hooks/useTimeLineInfo";
import useShowListStaff from "hooks/useShowListStaff";

interface IProps extends ModalProps {
  isVisible?: boolean;
  handleCancel: () => void;
}
const ModalEditTable = (props: IProps) => {
  const [tableEdit, setTableEdit] = useState<string | undefined>(undefined);
  const [sortListTableArray, setSortListTableArray] = useState<string[]>([]);
  const { setTimeLineInfo } = useSetTimeLineInfo();
  const { setOrderList } = useSetOrderList();
  const { showListStaff } = useShowListStaff();
  const userPlan = Cookies.get("userPlan");

  const { isMobile } = useIsMobile();

  const { data: listTableSession } = useQuery(
    queryKeys.listTableSession,
    getListTableSession
  ) as any;

  const { data: sortListTable } = useQuery(
    queryKeys.sortListTable,
    getListIndexTable
  ) as any;

  const updateTableIndex = useMutation(updateIndexTable);

  useEffect(() => {
    if (Array.isArray(sortListTable?.data) && !!props.isVisible) {
      setSortListTableArray(sortListTable?.data);
      setTableEdit(sortListTable?.data?.[0]);
      const table = listTableSession?.data?.find(
        (item: any) => item?._id === sortListTable?.data?.[0]
      );

      setTimeLineInfo(table?.timeLineInfo);
      setOrderList(table?.orderList);
    }
  }, [sortListTable, props.isVisible]);

  const handleSelectTable = (tableId?: string) => {
    setTableEdit(tableId);
    const table = listTableSession?.data?.find(
      (item: any) => item?._id === tableId
    );
    setTimeLineInfo(table?.timeLineInfo);
    setOrderList(table?.orderList);
  };

  const handleSortTable = (tableId: string, isDown?: boolean) => {
    if (Number(userPlan) === UserPlan.SubAccount) {
      return;
    }
    const listCurrent = [...sortListTableArray];

    const index = listCurrent.findIndex((item: string) => item === tableId);
    if (index === -1) return;

    const newIndex = isDown ? index + 1 : index - 1;

    if (newIndex < 0 || newIndex >= listCurrent.length) return;

    const temp = listCurrent[index];
    listCurrent[index] = listCurrent[newIndex];
    listCurrent[newIndex] = temp;
    updateTableIndex.mutate({ listSort: listCurrent });
    setSortListTableArray(listCurrent);
  };

  const handleGetTakuId = () => {
    const table = listTableSession?.data?.find(
      (item: any) => item?._id === tableEdit
    );
    if (!table) return "";
    return `${table?.tableConfig?.code}${table?.tableConfig?.no}`;
  };

  const handleGetListStaffNotPriority = () => {
    const table = listTableSession?.data?.find(
      (item: any) => item?._id === tableEdit
    );
    if (!table) return [];
    return table?.listStaffNotPriority;
  };

  const handleGetListStaffCandidacy = () => {
    const table = listTableSession?.data?.find(
      (item: any) => item?._id === tableEdit
    );
    if (!table) return [];
    return table?.listStaffCandidacy;
  };

  const handleGetActiveTable = () => {
    const table = listTableSession?.data?.find(
      (item: any) => item?._id === tableEdit
    );
    if (!table) return null;
    return table?.orderList;
  };
  return (
    <Modal
      open={props.isVisible}
      footer={null}
      closable={false}
      className={styles.modalEditTable}
      wrapClassName={styles.modalEditTableWrap}
      destroyOnClose
      centered
      width={"100vw"}
    >
      <div className={styles.modalEditTableContainer}>
        <div
          className={classNames(styles.contentContainer, {
            [styles.hideListStaff]: !showListStaff,
          })}
        >
          <div className={styles.header}>タイムテーブルー覧</div>

          <div
            className={classNames(
              styles.tableCodeContainer,

              {
                [styles.noDataContainer]: !(
                  Array.isArray(listTableSession?.data) &&
                  listTableSession?.data?.length > 0
                ),
              }
            )}
          >
            {Array.isArray(listTableSession?.data) &&
            listTableSession?.data?.length > 0 ? (
              listTableSession?.data
                ?.sort((a: any, b: any) => {
                  const indexA = sortListTableArray.indexOf(a?._id);
                  const indexB = sortListTableArray.indexOf(b?._id);

                  if (indexA === -1) return 1;
                  if (indexB === -1) return -1;

                  return indexA - indexB;
                })
                ?.map((item: any, index: number) => (
                  <TableItem
                    key={item?.id}
                    disableUp={index === 0}
                    disableDown={index === listTableSession?.data?.length - 1}
                    infoTable={item as any}
                    activeTableId={tableEdit}
                    handleSelectTable={handleSelectTable}
                    handleSortTable={handleSortTable}
                  />
                ))
            ) : (
              <div className={styles.noData}>
                現在はスタッフタイムテーブルがありません。メイン画面で卓を設定してください。
              </div>
            )}
          </div>
          <div className={styles.btnContainer}>
            <Button
              className={classNames(styles.btn, "btn-default")}
              onClick={() => {
                setTableEdit(undefined);
                setTimeLineInfo([]);
                setOrderList([]);
                props.handleCancel();
              }}
            >
              閉じる
            </Button>
          </div>
        </div>
        {!isMobile && (
          <TakuSetteiStaff
            tableEdit={tableEdit}
            listStaffNotPriority={handleGetListStaffNotPriority()}
            listStaffCandidacy={handleGetListStaffCandidacy()}
            cls={styles.takuSetteiStaffList}
            takuId={handleGetTakuId()}
            orderListSelect={handleGetActiveTable()}
            inViewAllTable={true}
          />
        )}
      </div>
    </Modal>
  );
};
export default ModalEditTable;
